import { useQuery } from 'react-query'

import type { DeduplicationKind } from '../config'
import { DeduplicationService } from '../services'
import type { SearchQueryParams } from '../types'

export const useDeduplicationSearch = (
  kind: DeduplicationKind,
  params: SearchQueryParams,
  enabled = true
) =>
  useQuery(
    ['deduplication-search', kind, params],
    () => DeduplicationService.search({ ...params, objectType: kind }),
    {
      enabled,
      keepPreviousData: true,
    }
  )
